import apiService from '../../../sdk/apiService';

// Action Creators - Zmanim
export const startFetchZmanim = () => ({
  type: "FETCH_ZMANIM_START"
});

export const successFetchZmanim = (zmanimData) => ({
  type: "FETCH_ZMANIM_SUCCESS",
  payload: zmanimData
});

export const failedFetchZmanim = (error) => ({
  type: "FETCH_ZMANIM_FAILURE",
  payload: error
});

// Action Creators - Hebrew Date
export const startFetchHebrewDate = () => ({
  type: "FETCH_HEBREW_DATE_START"
});

export const successFetchHebrewDate = (hebrewDateData) => ({
  type: "FETCH_HEBREW_DATE_SUCCESS",
  payload: hebrewDateData
});

export const failedFetchHebrewDate = (error) => ({
  type: "FETCH_HEBREW_DATE_FAILURE",
  payload: error
});

// Action Creators - Shabbat (for ZmanimWidget)
export const startFetchZmanimShabbat = () => ({
  type: "FETCH_ZMANIM_SHABBAT_START"
});

export const successFetchZmanimShabbat = (shabbatData) => ({
  type: "FETCH_ZMANIM_SHABBAT_SUCCESS",
  payload: shabbatData
});

export const failedFetchZmanimShabbat = (error) => ({
  type: "FETCH_ZMANIM_SHABBAT_FAILURE",
  payload: error
});

// Async Action - Zmanim
export const fetchZmanimActions = (coordinates) => {
  return async (dispatch) => {
    dispatch(startFetchZmanim());

    try {
      if (!coordinates || !coordinates.lat || !coordinates.lng) {
        throw new Error('חסרים קואורדינטות לארגון');
      }

      const zmanimData = await apiService.fetchZmanim(coordinates);
      dispatch(successFetchZmanim(zmanimData));
    } catch (error) {
      dispatch(failedFetchZmanim(error.message));
    }
  };
};

// Async Action - Hebrew Date
export const fetchHebrewDateActions = (date = new Date()) => {
  return async (dispatch) => {
    dispatch(startFetchHebrewDate());

    try {
      const hebrewDateData = await apiService.fetchHebrewDate(date);
      dispatch(successFetchHebrewDate(hebrewDateData));
    } catch (error) {
      dispatch(failedFetchHebrewDate(error.message));
    }
  };
};

// Async Action - Shabbat (for ZmanimWidget)
export const fetchZmanimShabbatActions = (coordinates) => {
  return async (dispatch) => {
    dispatch(startFetchZmanimShabbat());

    try {
      if (!coordinates || !coordinates.lat || !coordinates.lng) {
        throw new Error('חסרים קואורדינטות לארגון');
      }

      const shabbatData = await apiService.fetchShabbatTimes(coordinates);
      dispatch(successFetchZmanimShabbat(shabbatData));
    } catch (error) {
      dispatch(failedFetchZmanimShabbat(error.message));
    }
  };
};
